import React, { useEffect } from "react"
import DocumentMeta from "react-document-meta"
import { Link, useNavigate } from "react-router-dom"
import MobileMenu from "../components/MobileMenu"
const Imprint: React.FC = () => {
	const navigate = useNavigate()

	// SEO Meta Tags

	const meta = {
		// title: "Mit merci zum Muttertag filmreif Danke sagen!",
		// canonical: "https://arvato-hawaiian-tropic-2023.de/",
		// meta: {
		// 	name: {
		// 		robots: "noindex, nofollow",
		// 	},
		// },
	}

	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		})
	}, [])

	return (
		<DocumentMeta {...meta}>
			<div className="bg-greenBG md:min-h-[1400px] bg-[url('/src/bgimages/bg-green.png')] bg-full bg-no-repeat bg-[100%] bg-cover">
				<MobileMenu />
				<div className="mx-auto   py-8 px-4 text-white">
					<div className="mx-auto max-w-[800px]">
						<h2 className="h2 mb-8 mt-24 text-center font-Veener text-[32px] md:text-[52px] text-white lg:mt-24">Impressum</h2>
						<h3 className="h3 py-4 text-white mb-0 text-[24px] md:text-[42px]">Verantwortlich</h3>
						<p className=" mb-4">
							Danone Deutschland GmbH
							<br />
							Amtsgericht Frankfurt am Main, HRB: 112989
							<br />
							USt-ID Nr.: DE175657037
							<br />
							Bio-Kontrollstelle: DE-ÖKO-001
							<br />
							Geschäftsführer: Richard Trechman, Stephanie Enzinger
							<br />
							Vorsitzende des Aufsichtsrats: Corinna Ortner
						</p>
						<h3 className="h3 py-4 text-white mb-0 text-[24px] md:text-[42px]">Verbraucherservice</h3>
						<p className=" mb-4">
							Kostenfreie Hotline <br />
							Montag-Freitag 08:00 - 20:00 Uhr: <br />
							<a href="tel:08005557979" className="underline font-bold">
								0800 5557979
							</a>
						</p>
						<h3 className="h3 py-4 text-white mb-0 text-[24px] md:text-[42px]">Postanschrift</h3>
						<p className=" mb-4">
							Danone Deutschland GmbH
							<br />
							Am Hauptbahnhof 18
							<br />
							60329 Frankfurt am Main
							<br />
							E-Mail:{" "}
							<a href="mailto:info@volvic.de" className="underline font-bold">
								info@volvic.de
							</a>
						</p>
					</div>
					<div className=" py-10 pt-5 text-center text-xl text-white">
						<Link
							to="/"
							className=" tracking-wide mb-6 block w-[100%] rounded-full bg-[#FFDD08]   p-4 font-Veener text-[29px]  sm:text-[32px] leading-none uppercase text-[#007331] sm:w-[auto]  lg:inline-block lg:py-4 lg:px-4"
						>
							Zurück
						</Link>
					</div>
				</div>
			</div>
		</DocumentMeta>
	)
}
export default Imprint
